import React from 'react';
import PropTypes from 'prop-types';
import useHeaderHeight from '@/hooks/useHeaderHeight';
import { DEFAULT_CONTENT } from '@/constants/appConfig';
import {
  WelcomeContainer,
  WelcomeHeader,
  Heading,
  Subtext,
} from './styles/WelcomeContent.styles';

/**
 * WelcomeContent Component
 * Displays a welcoming landing page when no specific route is selected
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.message] - Optional custom message to display
 * @return {JSX.Element} Welcome content page
 */
const WelcomeContent = ({ message = DEFAULT_CONTENT.NAVIGATION_MESSAGE }) => {
  const headerHeight = useHeaderHeight();

  if (headerHeight === null) return null;

  return (
    <WelcomeContainer headerHeight={headerHeight}>
      <WelcomeHeader>
        <Heading>{DEFAULT_CONTENT.WELCOME_HEADING}</Heading>
        {message && <Subtext>{message}</Subtext>}
      </WelcomeHeader>
    </WelcomeContainer>
  );
};

WelcomeContent.propTypes = {
  message: PropTypes.string,
};

export default WelcomeContent;
